module.exports = __webpack_public_path__ + "assets/img/GlossaryBAIOS.fca28afa.png";